module.exports = __webpack_public_path__ + "static/media/logo-tech.b08886d4.svg";